(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dropmagic-style"]) return;
  try {
    

(function patchBodyClass() {
  if (document.body) {
    document.body.classList.add('theme__modal--callback');
  } else {
    setTimeout(patchBodyClass, 10);
  }
})();



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-capybara"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-section-id]').forEach(function (root) {
    if (!root.classList.contains('cpdp')) return;
    if (root.dataset.cpdpInit) return;
    root.dataset.cpdpInit = '1';

    var variantsScript = root.querySelector('[data-cpdp-variants]');
    var currencyScript = root.querySelector('[data-cpdp-currency]');
    var variants = variantsScript ? JSON.parse(variantsScript.textContent) : [];
    var currency = currencyScript ? JSON.parse(currencyScript.textContent) : 'USD';
    var moneyFormatter;
    try {
      moneyFormatter = new Intl.NumberFormat(navigator.language || 'en-US', { style: 'currency', currency: currency });
    } catch (e) {
      moneyFormatter = { format: function (n) { return '$' + n.toFixed(2); } };
    }

    function formatMoney(cents) {
      return moneyFormatter.format(cents / 100);
    }

    var mainImg = root.querySelector('[data-cpdp-main] img');
    root.querySelectorAll('[data-cpdp-thumb]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var src = btn.dataset.src;
        var alt = btn.dataset.alt || '';
        if (mainImg && src) {
          mainImg.src = src;
          mainImg.srcset = '';
          if (alt) mainImg.alt = alt;
        }
        root.querySelectorAll('[data-cpdp-thumb]').forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
      });
    });

    function getSelectedOptions() {
      var values = [];
      root.querySelectorAll('[data-cpdp-option-index]').forEach(function (fieldset) {
        var input = fieldset.querySelector('input[type="radio"]:checked');
        if (input) values.push(input.value);
      });
      return values;
    }

    function findVariant(opts) {
      return variants.find(function (v) {
        return v.options.length === opts.length && v.options.every(function (o, i) { return o === opts[i]; });
      });
    }

    function updateForVariant(v) {
      var idInput = root.querySelector('[data-cpdp-variant-id]');
      var priceEl = root.querySelector('[data-cpdp-price]');
      var compareEl = root.querySelector('[data-cpdp-compare]');
      var savingsEl = root.querySelector('[data-cpdp-savings]');
      var atcBtn = root.querySelector('[data-cpdp-atc]');
      var atcText = root.querySelector('[data-cpdp-atc-text]');
      var atcPrice = root.querySelector('[data-cpdp-atc-price]');

      if (!v) {
        if (atcBtn) { atcBtn.disabled = true; if (atcText) atcText.textContent = 'Unavailable'; }
        return;
      }

      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.textContent = formatMoney(v.price);
      if (priceEl) priceEl.classList.toggle('cpdp__price--sale', v.compare_at_price && v.compare_at_price > v.price);

      if (v.compare_at_price && v.compare_at_price > v.price) {
        var pct = Math.round((v.compare_at_price - v.price) / v.compare_at_price * 100);
        if (compareEl) { compareEl.textContent = formatMoney(v.compare_at_price); compareEl.hidden = false; }
        if (savingsEl) { savingsEl.textContent = 'Save ' + pct + '%'; savingsEl.hidden = false; }
      } else {
        if (compareEl) compareEl.hidden = true;
        if (savingsEl) savingsEl.hidden = true;
      }

      if (atcBtn) atcBtn.disabled = !v.available;
      if (atcText && atcPrice) {
        if (v.available) {
          atcText.innerHTML = 'Add to cart — <span data-cpdp-atc-price>' + formatMoney(v.price) + '</span>';
        } else {
          atcText.textContent = 'Sold out';
        }
      }

      if (history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        history.replaceState({}, '', url);
      }

      root.querySelectorAll('[data-cpdp-option-selected]').forEach(function (el) {
        var idx = parseInt(el.dataset.cpdpOptionSelected, 10);
        if (!isNaN(idx) && v.options[idx]) el.textContent = v.options[idx];
      });
    }

    root.querySelectorAll('[data-cpdp-option-value]').forEach(function (input) {
      input.addEventListener('change', function () {
        var opts = getSelectedOptions();
        var v = findVariant(opts);
        updateForVariant(v);
      });
    });

    var qtyInput = root.querySelector('[data-cpdp-qty-input]');
    root.querySelectorAll('[data-cpdp-qty]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!qtyInput) return;
        var delta = parseInt(btn.dataset.cpdpQty, 10) || 0;
        var next = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + delta);
        qtyInput.value = next;
      });
    });

    var countdownEl = root.querySelector('[data-cpdp-countdown]');
    if (countdownEl) {
      var output = countdownEl.querySelector('[data-cpdp-countdown-output]');
      var endTs = Date.parse(countdownEl.dataset.end);
      function tick() {
        var now = Date.now();
        var diff = Math.max(0, endTs - now);
        if (diff <= 0) { countdownEl.style.display = 'none'; return; }
        var d = Math.floor(diff / 86400000);
        var h = Math.floor(diff % 86400000 / 3600000);
        var m = Math.floor(diff % 3600000 / 60000);
        var s = Math.floor(diff % 60000 / 1000);
        var pad = function (n) { return n < 10 ? '0' + n : '' + n; };
        if (output) output.textContent = (d > 0 ? d + 'd ' : '') + pad(h) + ':' + pad(m) + ':' + pad(s);
      }
      tick();
      setInterval(tick, 1000);
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
